(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ct-collection-hero-editor"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initHero = (root = document) => {
    root.querySelectorAll('[data-ct-editor-hero]').forEach((hero) => {
      if (hero.dataset.initialized === 'true') return;
      hero.dataset.initialized = 'true';

      const slides = Array.from(hero.querySelectorAll('[data-ct-editor-hero-slide]'));
      const dots = Array.from(hero.querySelectorAll('[data-ct-editor-hero-dot]'));
      const prev = hero.querySelector('[data-ct-editor-hero-prev]');
      const next = hero.querySelector('[data-ct-editor-hero-next]');
      const autoplay = hero.dataset.autoplay === 'true';
      const speed = Number(hero.dataset.speed || 7000);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let index = 0;
      let timer;

      const show = (nextIndex) => {
        if (!slides.length) return;
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-current', i === index ? 'true' : 'false'));
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = undefined;
      };

      const start = () => {
        stop();
        if (autoplay && slides.length > 1 && !reduceMotion) {
          timer = window.setInterval(() => show(index + 1), speed);
        }
      };

      prev?.addEventListener('click', () => { show(index - 1); start(); });
      next?.addEventListener('click', () => { show(index + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.ctEditorHeroDot)); start(); }));

      // Info-knop en boekingskeuze delen dezelfde dialog-logica (aria-controls -> dialog-id).
      // Zonder showModal-ondersteuning volgt de boekingslink gewoon zijn href.
      hero.querySelectorAll('[data-ct-editor-hero-info-open], [data-ct-editor-hero-booking-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          const dialog = hero.querySelector('#' + CSS.escape(trigger.getAttribute('aria-controls')));
          if (!dialog || typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          event.stopPropagation();
          stop();
          dialog.showModal();
        });
      });

      hero.querySelectorAll('[data-ct-editor-hero-dialog]').forEach((dialog) => {
        dialog.querySelector('[data-ct-editor-hero-info-close]')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', start);
      });

      // Meetbaarheid: keuze NL/BE naar de dataLayer (alleen als GTM/gtag aanwezig is).
      hero.querySelectorAll('[data-ct-booking-choice]').forEach((option) => {
        option.addEventListener('click', () => {
          if (!Array.isArray(window.dataLayer)) return;
          window.dataLayer.push({
            event: 'ct_booking_choice',
            booking_country: option.dataset.ctBookingChoice,
            booking_url: option.href
          });
        });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', start);

      document.addEventListener('shopify:block:select', (event) => {
        const selected = slides.findIndex((slide) => slide.dataset.blockId === event.detail.blockId);
        if (selected >= 0) {
          stop();
          show(selected);
        }
      });

      document.addEventListener('shopify:block:deselect', start);
      start();
    });
  };

  initHero();
  document.addEventListener('shopify:section:load', (event) => initHero(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
